import { render, staticRenderFns } from "./GlobalIndicatorsFinancialProfile.vue?vue&type=template&id=328980b0&"
import script from "./GlobalIndicatorsFinancialProfile.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsFinancialProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports